import $ from "jquery";
import tinybind from "tinybind";

import { formatMoney } from "../tools/moneyFormats";
import PerfectScrollbar from "perfect-scrollbar";
import recommendations, {
  mountRecommendationSection,
} from "./product/recommendations";
import jquery from "jquery";

const $variantsSelector = $("[data-all-variants]");
let data = {
  cart: {},
  update(newCart) {
    this.cart = newCart;
  },
  setRedirect(e) {
    e.preventDefault();
    goToCheckout();
  },
};

let open = false;
const $minicart = $("[data-minicart]");
let scrollBar = null;
const $minicart_block = $("#minicart-block");
const $minicart_empty = $("#minicart-empty");

const initMinicartScrollbar = function () {
  const isTouch =
    "ontouchstart" in window ||
    window.matchMedia("(max-width: 989px)").matches;

  if (isTouch) return;

  const el = document.querySelector("#minicart-block");
  if (el && !scrollBar) {
    scrollBar = new PerfectScrollbar(el);
  }
};

// cartShow();
refreshRecommend(3000);
const addToCart = function (id, qty, properties) {
  let data = {
    quantity: qty,
    id: id,
    properties: {},
  };

  if (properties != null) {
    // Check for specific properties first (like subscription)
    if (
      properties["shipping_interval_frequency"] &&
      properties["shipping_interval_unit_type"] &&
      properties["subscription_id"]
    ) {
      data["properties"]["shipping_interval_frequency"] =
        properties["shipping_interval_frequency"];
      data["properties"]["shipping_interval_unit_type"] =
        properties["shipping_interval_unit_type"];
      data["properties"]["subscription_id"] = properties["subscription_id"];
    }

    // Handle 'preorder' property separately
    if (properties["preorder"]) {
      data["properties"]["preorder"] = properties["preorder"];
    }

    // Add all other properties, including 'Ship On' if present
    $.each(properties, function (key, value) {
      // Add each property, regardless of 'preorder'
      if (key !== "preorder") {
        data["properties"][key] = value;
      }
    });
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      open = true;
      updateMinicart();
    },
    error: function (response) {
      successCallback(response.responseJSON);
      console.error("Can't add item to cart");
    },
  });
};
const successCallback = function (response) {
  let $errorMessageWrapper = document.querySelector(
    "[data-product-error-wrapper]",
  );
  if (!$errorMessageWrapper) return;
  let $errorMessageContent = $errorMessageWrapper.querySelector(
    "[data-product-error-message]",
  );

  if (response.status && typeof response.status === "number") {
    if ($errorMessageContent) {
      $errorMessageWrapper.classList.remove("visually-hidden");
      $errorMessageContent.textContent = response.description;
    }

    setTimeout(() => {
      $errorMessageWrapper.classList.add("visually-hidden");
      if (response.description) errorMessage.textContent = "";
    }, 5000);
  }
};

window.newAddToCart = function (
  items,
  openCart,
  successCallback,
  catchCallback,
) {
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/javascript`,
      "X-Requested-With": "XMLHttpRequest",
    },
  };

  config.body = JSON.stringify({
    items,
  });

  fetch(`/cart/add.js`, config)
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.status) {
        if (successCallback) successCallback(json);
      } else {
        open = true;
        updateMinicart();
      }
    })
    .catch((error) => {
      if (catchCallback) catchCallback();
      console.error(error);
    });
};

const getProperties = function ($productForm) {
  let properties = {}; // Ensure properties is an object, not an array

  // Check for elements with data-product-property first
  $productForm.find("[data-product-property]").each(function (index, element) {
    let key = $(element).data("product-property"); // Get the data-product-property value
    let value = $(element).val(); // Get the value of the element
    if (key && value) {
      properties[key] = value; // Add to properties object
    }
  });

  // Fallback: read other form elements, excluding Shopify-internal and variant-selection fields
  $productForm.find("[name], [data-property]").each(function (index, element) {
    const type = element.type;
    const name = $(element).attr("name") || "";
    // Skip unchecked radios/checkboxes — val() returns the attribute value, not the checked state
    if ((type === "radio" || type === "checkbox") && !element.checked) return;
    // Skip fields that are not cart properties
    if (type === "submit" || name === "ID" || name === "options[]" || name.startsWith("product-option-")) return;
    let key = $(element).data("property") || name;
    let value = $(element).val();
    if (key && value) {
      properties[key] = value;
    }
  });

  // Handle specific case for "preorder" if out of stock
  const $variantSelected = $(
    "option:selected",
    $productForm.find("[data-all-variants]"),
  );
  if (
    $variantSelected.attr("data-inventory-policy") == "continue" &&
    parseInt($variantSelected.attr("data-inventory-quantity")) <= 0
  ) {
    properties["preorder"] = "preorder";
  }

  return properties;
};

const addToCartHandler = function ($productForm) {
  if ($productForm instanceof jquery) {
    $productForm = $productForm;
  } else {
    $productForm = $($productForm);
  }

  const $variantSelected = $(
    "option:selected",
    $($productForm).find("[data-all-variants]"),
  );
  let variantId = $variantSelected.val();
  if ($variantSelected.data("discount-variant-id") != "") {
    variantId = $variantSelected.data("discount-variant-id");
  }
  const qty = $productForm.find("[data-qty]").val() || 1;

  // get the Ships-on
  let getShipOn =
    $("#addToCartForm div.ships-on").css("display") === "none"
      ? ""
      : $("#addToCartForm div.ships-on").text().trim();

  let properties = getProperties($productForm);
  properties["Ship On"] = getShipOn;
  // console.log("Properties from getProperties 1:", properties);

  if (variantId) {
    addToCart(variantId, qty, properties);
  } else if (
    $productForm
      .find("[data-all-variants] option:selected")
      .data("multi-variants")
  ) {
    let $variants = $productForm
      .find("[data-all-variants] option:selected")
      .data("multi-variants");
    $variants.forEach(function (id) {
      addToCart(id, qty, properties);
    });
  } else {
    console.error(
      "minicart.js: can't add item to cart, wrong variantId",
      variantId,
    );
  }
};

const closeCartModal = function () {
  $minicart.removeClass("is-open");
  $("html, body").removeClass("is-cart-open");
};

function cartShow() {
  if (data.cart.item_count > 0) {
    $minicart_empty.addClass("minicart_none");
    $minicart_block.removeClass("minicart_none");
  } else {
    $minicart_block.addClass("minicart_none");
    $minicart_empty.removeClass("minicart_none");
  }
}

function refreshRecommend(t) {
  var time = t;
  if (t == undefined || t == null) {
    time = 0;
  }
  setTimeout(function () {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        var cartItems = cart["items"];
        if (cart.item_count > 0) {
          var $item = cartItems.pop();
          var id = $item["product_id"];
          mountRecommendationSection(id);
          //   $("[data-minicart].minicart").addClass('upsell_include');
          //   // $("[data-minicart].minicart .upsell_recommend").slick();
          // } else {
          //   $("[data-minicart].minicart").removeClass('upsell_include');
          //   setTimeout(function () {
          //     $("[data-minicart].minicart .upsell_static").slick('setPosition');
          //   }, 150);
        }
        //remove '-xsell' url string from cart items
        $(".minicart_main .minicart__item:not(.crossell_item)").each(
          function () {
            var $xlink = $(this).find("a");
            var xhref = $xlink.attr("href");
            if (xhref && xhref.includes("-xsell")) {
              var newxHref = xhref.replace("-xsell", "");
              $xlink.attr("href", newxHref);
            }
          },
        );
      },
    });
  }, time);
}

const removeFromCart = function ($item) {
  var updateQuery = "updates[" + $item.attr("data-id") + "]=" + 0;
  jQuery.post("/cart/update.js", updateQuery, function () {
    updateMinicart();
    refreshRecommend();
  });
};

function reChargeProcessCart() {
  let token = "";

  function get_cookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
  }
  do {
    token = get_cookie("cart");
  } while (token == undefined);

  try {
    var ga_linker = ga.getAll()[0].get("linkerParam");
  } catch (err) {
    var ga_linker = "";
  }
  var customer_param =
    "{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}";
  document.location.href =
    "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
    myshopify_domain +
    "&cart_token=" +
    token +
    "&" +
    ga_linker +
    "&" +
    customer_param;
}

const goToCheckout = function () {
  let hasSubscription = false;
  for (let i = 0; i < data.cart.items.length; i++) {
    let item = data.cart.items[i];
    if (item.product_title.includes("Auto renew")) {
      hasSubscription = true;
    }
  }

  if (hasSubscription) {
    reChargeProcessCart();
  } else {
    document.location.href = "/checkout";
  }
};
const checkFreeItem = function () {
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    success: function (result) {
      const newCart = result;
      data.update(result);

      var cartItems = newCart.items,
        qtyInTheCart = 0,
        freeQtyInCart = {},
        cartUpdates = {},
        freeAlreadyInCart = false,
        freeProductHandle = $(".minicart-free-item .handle").text(),
        freeProductVariants = [],
        freeProductVariantId = parseInt(
          $(".minicart-free-item .default_variant").text(),
        );

      if (newCart.item_count > 0) {
        for (var i = 0; i < cartItems.length; i++) {
          if (cartItems[i].handle === freeProductHandle) {
            //console.log("Free one in cart already cart: ", cartItems[i].handle );
            //qtyInTheCart = cartItems[i].quantity;
            freeAlreadyInCart = true;
            var found = jQuery.inArray(
              cartItems[i].variant_id,
              freeProductVariants,
            );
            if (found < 0) {
              freeProductVariants.push(cartItems[i].variant_id);
            }
            break;
          }
        }
        var main1 = $(".minicart-free-item .main_product_1_handle").text();
        var main2 = $(".minicart-free-item .main_product_2_handle").text();

        for (var i = 0; i < cartItems.length; i++) {
          if (cartItems[i].handle === main1 || cartItems[i].handle === main2) {
            //console.log("If in cart: ", cartItems[i].handle );
            //console.log("Then add free product");
            var colorOfBlender = "";
            qtyInTheCart = cartItems[i].quantity;
            //console.log("CArt items ", cartItems[i]);
            //freeQtyInCart[cartItems[i].variant_id] = cartItems[i].quantity;
            if (cartItems[i].options_with_values != null) {
              var options = cartItems[i].options_with_values;
              for (var j = 0; j < options.length; j++) {
                var color = options[j];
                if (color.name === "Color") {
                  colorOfBlender = color.value;
                }
              }
            }
            var qtyByColor = freeQtyInCart[colorOfBlender]
              ? freeQtyInCart[colorOfBlender]
              : 0;
            freeQtyInCart[colorOfBlender] = qtyByColor + cartItems[i].quantity;
            //console.log("Color of blender: ", colorOfBlender);

            /*jQuery.getJSON('/products/'+ freeProductHandle +'.js', function(product) {
              var freeVariants = product.variants;
              for (var p=0; p<freeVariants.length; p++) {
                  if (freeVariants[p]['option1'] === colorOfBlender) {
                    if (freeVariants[p]['available']) {
                      freeProductVariantId = freeVariants[p]['id'];
                    }

                    break;
                  }
              }
            }).done(function() {*/

            //console.log("freeProductVariantId ", freeProductVariantId);
            var found = jQuery.inArray(
              freeProductVariantId,
              freeProductVariants,
            );
            //console.log("Found ", found);
            //console.log("qtyInTheCart ", qtyInTheCart);
            //console.log("freeQtyInCart", freeQtyInCart);
            if (freeProductVariantId > 0) {
              if (found < 0) {
                jQuery
                  .post("/cart/add.js", {
                    quantity: freeQtyInCart[colorOfBlender],
                    id: freeProductVariantId,
                  })
                  .done(function () {
                    freeProductVariants.push(freeProductVariantId);
                    updateMinicart();
                  });
              } else {
                if (freeQtyInCart[colorOfBlender] > 1) {
                  jQuery
                    .post("/cart/change.js", {
                      quantity: freeQtyInCart[colorOfBlender],
                      id: freeProductVariantId,
                    })
                    .done(function () {
                      updateMinicart();
                    });
                }
              }
            }
            //});
          }
        }
      }
    },
  });
};
const addCompareAtPrice = function (cart) {
  cart.items.forEach(function (item) {
    $.ajax({
      url: "/products/" + item.handle + ".js",
      dataType: "json",
      async: false,
      success: function (product) {
        product.variants.forEach(function (variant) {
          if (variant.id == item.variant_id) {
            if (variant.compare_at_price != null)
              item["compare_at_price"] = variant.compare_at_price;
          }
        });
      },
    });
  });
  return cart;
};

const updateMinicart = function () {
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    success: function (result) {
      addCompareAtPrice(result);
      data.update(result);

      updateCartCount();
      let total_price = result.total_price;
      let original_subtotal = 0;

      result.items.forEach(function (item) {
        let item_original_price = item.compare_at_price || item.price;
        original_subtotal += item_original_price * item.quantity;
      });

      var offer_min_limit = $(".offer-cart-slider").data("offer_min_limit");
      var offer_amount = $(".offer-cart-slider").data("offer_amount");

      var leftOffer = formatMoney(offer_min_limit - total_price);
      var percentage = (total_price / offer_min_limit) * 100;
      var offerPrice = formatMoney(total_price + offer_amount);
      var total_saving = original_subtotal - total_price;

      $(".offer-cart-slider #offer_min_limit").text(leftOffer);

      if (result.total_discount == 3000) {
        percentage = 100;
        $(".offer-cart-slider .completed").removeClass("hide");
        $(".offer-cart-slider .uncompleted").addClass("hide");
        $(".minicart__footer .saving-offer-note").removeClass("hide");
        $(".minicart__footer .offer-price").removeClass("hide");
        $(".minicart__footer .offer-price span").text(offerPrice);
        $(".minicart__footer .normal-price").addClass("has-offer");
      } else {
        $(".offer-cart-slider .uncompleted").removeClass("hide");
        $(".offer-cart-slider .completed").addClass("hide");
        $(".minicart__footer .saving-offer-note").addClass("hide");
        $(".minicart__footer .offer-price").addClass("hide");
        $(".minicart__footer .normal-price").removeClass("has-offer");
      }

      $(".offer-cart-slider .offer-slider-fill").css("width", percentage + "%");

      // Update the original subtotal in the minicart footer
      $(".minicart__footer .original-subtotal").text(formatMoney(total_saving));

      // Hide the original subtotal div if total_saving is 0 or less
      if (total_saving <= 0) {
        $(".minicart__footer .minicart__totalsavings").hide();
      } else {
        $(".minicart__footer .minicart__totalsavings").show();
      }
      checkShipOnProperty();
      checkCartAndFetchCrossSell();

      if (open) {
        $minicart.addClass("is-open");
        $("html, body").addClass("is-cart-open");
        $("body").addClass("no-scroll");
        open = false;
        refreshRecommend();
        $("#upsell-container").addClass("active_usc");
      }
      cartShow();
    },
  });
};

// Call updateMinicart function on document ready
$(document).on("ready", function () {
  updateMinicart();
});

const updateCartCount = function () {
  let cartCount = "[data-cart-count]";
  var count = data.cart.item_count;
  $(cartCount).text(data.cart.item_count);
  const $body = $("body");
  if (count == 0) {
    $("[data-cart-count]").parent(".cart-count-wrap").addClass("empty_cart");
    if (
      $body.hasClass("template-product") ||
      $body.hasClass("template-collection")
    ) {
    } else {
      $("[data-nav-cart]").removeAttr("data--hidden");
      $("[data-nav-shop]").attr("data--hidden", true);
      $("[data-nav-shop-btn]").removeAttr("data--hidden");
    }
  } else {
    $("[data-cart-count]").parent(".cart-count-wrap").removeClass("empty_cart");
    if (
      $body.hasClass("template-product") ||
      $body.hasClass("template-collection")
    ) {
    } else {
      $("[data-nav-cart]").removeAttr("data--hidden");
      $("[data-nav-shop]").removeAttr("data--hidden");
      $("[data-nav-shop-btn]").attr("data--hidden", true);
    }
  }
};

const updateFreeShippingBar = function () {
  const theme = window.theme || {};
  const strings = theme.strings || {};
  // Threshold comes from the theme settings so each market can match its own
  // shipping rate, rather than a hardcoded cents value.
  const elgiblePrice = theme.freeShippingThreshold;

  if (!elgiblePrice) return;

  if (data.cart.total_price >= elgiblePrice) {
    $("[data-free-shipping-label]").html(strings.freeShippingUnlocked || "");
    $("[data-free-shipping-percent]").css("width", "100%");
  } else {
    const remainingPrice = parseInt(elgiblePrice - data.cart.total_price);
    const percent = parseInt((data.cart.total_price * 100) / elgiblePrice);
    $("[data-free-shipping-label]").html(
      (strings.freeShippingRemaining || "").replace(
        "{{ amount }}",
        formatMoney(remainingPrice),
      ),
    );
    $("[data-free-shipping-percent]").css("width", percent + "%");
  }
};

const eventHandlers = function () {
  $(document).on("click", ".beast-checkout", function (e) {
    e.preventDefault();
    goToCheckout();
  });

  $(document).on("click", "[data-add-to-cart]", function (e) {
    e.preventDefault();

    if ($(".product-preorder-item.added").length > 0) {
      var data = [];
      var _this = $(this);
      $(".product-preorder-item.added").each(function () {
        var variant_id = $(this)
          .find(".product-preorder-atc-form")
          .attr("data-id");
        var item = {
          id: variant_id,
          quantity: 1,
        };
        data.push(item);
      });
      data.push({
        id: $(this)
          .closest(".product-form")
          .find("[data-selected-variant-id]")
          .val(),
        quantity: 1,
      });

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: data,
        },
        dataType: "json",
        success: function () {
          //$('[data-add-to-cart-upsell=true]').parent().find('[data-upsell-btn]').trigger('click');
          open = true;
          updateMinicart();
        },
      });
    } else {
      // ADD FREE GIFT ON Mega & Mighty PDP
      // if ($('body').hasClass('template-product-bundle-mega') || $('body').hasClass('template-product-bundle-mighty')) {

      //     // get Ship On data
      //     let ship_on_bm = $('#addToCartForm div.ships-on').css('display') === 'none' ? '' : $('#addToCartForm div.ships-on').text().trim();

      //     $('[data-popup]').addClass('is-hidden');
      //     const prodId = $(this).closest(".product-form").data("productid");
      //     //const prodId = $('form#addToCartForm').data("productid");
      //     const varId = $(this).closest(".product-form").find("[data-selected-variant-id]").val();

      //     // Initialize an array to hold product data
      //     let productsToAdd = [{
      //       id: varId,
      //       quantity: 1,
      //       properties: {
      //         'Ship On': ship_on_bm
      //       }
      //     }];

      //     // Free gift with Mega 1200 or Mighty 850
      //     if (prodId == 8019201360063 || prodId == 7989170405567){
      //       let secondProductData = {
      //         id: 43804442132671, // product.id of Fuel Up Free Gift
      //         quantity: 1,
      //         properties: null
      //       };
      //       productsToAdd.push(secondProductData);
      //     }

      //     // AJAX call to add all products
      //     $.ajax({
      //       type: 'POST',
      //       url: '/cart/add.js',
      //       data: { items: productsToAdd },
      //       dataType: 'json',
      //       success: function (response) {
      //         //console.log('Products added successfully:', response);
      //         open = true;
      //         updateMinicart();
      //       },
      //       error: function (xhr, status, error) {
      //         console.error('Error adding products:', error);
      //       }
      //     });

      //   } else {

      // NORMAL CODE
      $("[data-popup]").addClass("is-hidden");
      let productForm;

      $(this).closest("[data-product-form]").length > 0
        ? (productForm = $(this).closest("[data-product-form]"))
        : (productForm = this.form);

      addToCartHandler(productForm);
      // }
    }
  });

  $(document).on(
    "click",
    ".sticky-bottom [data-add-to-cart].add-to-cart.btn",
    function (e) {
      e.preventDefault();
      if ($(".product-preorder-item.added").length > 0) {
        var data = [];
        var _this = $(this);
        $(".product-preorder-item.added").each(function () {
          var variant_id = $(this)
            .find(".product-preorder-atc-form")
            .attr("data-id");
          var item = {
            id: variant_id,
            quantity: 1,
          };
          data.push(item);
        });
        data.push({
          id: $(this).closest(".sticky-form").find(".sticky-variants").val(),
          quantity: 1,
        });

        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: data,
          },
          dataType: "json",
          success: function () {
            //$('[data-add-to-cart-upsell=true]').parent().find('[data-upsell-btn]').trigger('click');
            open = true;
            //checkFreeItem();
            updateMinicart();
          },
        });
      } else {
        // // ADD FREE GIFT ON Mega & Mighty PDP
        // if ($('body').hasClass('template-product-bundle-mega') || $('body').hasClass('template-product-bundle-mighty')) {
        //   const pidv = $(this).closest(".sticky-form").find(".sticky-variants option:selected").attr("pid-value");
        //   const variant_id = $(this).closest(".sticky-form").find(".sticky-variants").val();
        //   // get Ship On data
        //   let ShipOnBms = $('.custom-variants_select div.active').data('ship-on');
        //   // Initialize an array to hold product data
        //   let productsToAdd = [{
        //     id: variant_id,
        //     quantity: 1,
        //     properties: {
        //       'Ship On': ShipOnBms
        //     }
        //   }];

        //   // Free gift with Mega 1200 or Mighty 850
        //   if (pidv == 8019201360063 || pidv == 7989170405567) {
        //     let secondProductData = {
        //       id: 43804442132671, // product.id of Fuel Up Free Gift
        //       quantity: 1
        //     };
        //     productsToAdd.push(secondProductData);
        //   }

        //   // AJAX call to add all products
        //   $.ajax({
        //     type: 'POST',
        //     url: '/cart/add.js',
        //     data: { items: productsToAdd },
        //     dataType: 'json',
        //     success: function (response) {
        //       //console.log('Products added successfully:', response);
        //       open = true;
        //       updateMinicart();
        //     },
        //     error: function (xhr, status, error) {
        //       console.error('Error adding products:', error);
        //     }
        //   });
        // } else {
        //Standard Code

        // get Ship On data
        let getShipOn = $(".custom-variants_select div.active").data("ship-on");
        const lineItemProperties = { "Ship On": getShipOn };

        var variant_id = $(this)
          .closest(".sticky-form")
          .find(".sticky-variants")
          .val();
        addToCart(variant_id, 1, lineItemProperties);
        // }
      }
    },
  );

  $(document).on("click", "[data-sticky-atc]", function (e) {
    e.preventDefault();

    var $form = $(this).closest("form");
    var variantId = $form.find('[name="id"]').val();
    addToCart(variantId, 1, null);
  });

  $(document).on("click", "[data-quick-atc-swatch]", function (e) {
    e.stopPropagation();
    const $quickATCForm = $(this).closest("[data-quick-atc-wrap]");
    var colorName = $(this).attr("data-color-name");
    const otherForm = $(this).attr("data-other");
    const thisID = $(this).attr("data-product-id");
    const otherPopup = $("._popup");
    var $learn_more_link = $quickATCForm.find("[data-pc-learn-more]");
    var $quick_atc_btn = $quickATCForm.find("[data-quick-atc-btn]");
    $quickATCForm.find("[data-quick-atc-swatch]").removeClass("checked");
    $(this).addClass("checked");
    if ($(this).attr("data-variant-image") != "") {
      $quickATCForm
        .find("[data-quick-atc-image]")
        .attr("src", $(this).data("variant-image"));
      $quickATCForm
        .find("[data-second-image]")
        .attr("src", $(this).data("variant-hover-image"));
      $quickATCForm.find("[data-quick-atc-image]").attr("srcset", "");
      $quickATCForm.find("[data-second-image]").attr("srcset", "");
    }

    otherPopup.each(function () {
      if ($(this).data("product-id") != thisID) {
        var mainImage = $(this)
          .find('[data-color-name="' + colorName + '"]')
          .data("variant-image");
        var altImage = $(this)
          .find('[data-color-name="' + colorName + '"]')
          .data("variant-hover-image");
        $(".product-" + otherForm)
          .find("[data-quick-atc-image]")
          .attr("src", mainImage);
        $(".product-" + otherForm)
          .find("[data-second-image]")
          .attr("src", altImage);
        $(".product-" + otherForm)
          .find("[data-quick-atc-image]")
          .attr("srcset", "");
        $(".product-" + otherForm)
          .find("[data-second-image]")
          .attr("srcset", "");
      }
    });
    if ($(this).attr("data-variant-available") != "true") {
      $quick_atc_btn.attr("disabled", true);
    } else {
      $quick_atc_btn.attr("disabled", false);
    }
    $quick_atc_btn.text($(this).data("variant-btn"));
    $quickATCForm.attr("data-variant-id", $(this).data("variant-id"));
    $learn_more_link.attr("href", $(this).data("variant-url"));
    $(this)
      .closest(".product-cell-wrap")
      .find(".product-cell__img a")
      .attr("href", $(this).data("variant-url"));

    var $btn = $quickATCForm.find("[data-quick-atc-btn]");
    if ($(this).hasClass("is-disabled")) {
      $btn.addClass("disabled");
      $btn.find("[data-btn-label]").text("sold out");
    } else {
      $btn.removeClass("disabled");
      $btn.find("[data-btn-label]").text("add");
    }

    var colorName = $(this).attr("data-color-name");
    var originPrice = $(this).attr("data-variant-price");
    var comparePrice = $(this).attr("data-variant-compare-price");

    //console.log("originPrice ", originPrice);
    //console.log("comparePrice ", comparePrice);

    if (
      typeof comparePrice != "undefined" &&
      comparePrice != "" &&
      comparePrice > originPrice
    ) {
      $(this)
        .closest(".product-cell-wrap")
        .find(".product-cell-price")
        .html(
          formatMoney(originPrice) +
            ' &nbsp;<s class="was-price">' +
            formatMoney(comparePrice) +
            "ር ",
        );
      $(this)
        .closest(".cart-else-item")
        .find(".show-on-hover")
        .text(formatMoney(originPrice));
    } else {
      $(this)
        .closest(".product-cell-wrap")
        .find(".product-cell-price")
        .text(formatMoney(originPrice));
      $(this)
        .closest(".cart-else-item")
        .find(".show-on-hover")
        .text(formatMoney(originPrice));
    }
  });

  $(document).on("click", "[data-upsell-atc-swatch]", function (e) {
    const $upsellForm = $(this).closest("[data-upsell-wrap]");
    $upsellForm.find("[data-upsell-atc-swatch]").removeClass("checked");
    $(this).addClass("checked");
    if ($(this).data("variant-image") != "") {
      $upsellForm
        .find("[data-upsell-image]")
        .css("background-image", "url(" + $(this).data("variant-image") + ")");
    }
    $upsellForm.attr("data-variant-id", $(this).data("variant-id"));
    $upsellForm.attr("data-variant-price", $(this).data("variant-price"));
  });

  $(document).on("click", "[data-quick-atc-btn]", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $quickATCForm = $(this).closest("[data-quick-atc-wrap]");
    const variantId = $quickATCForm.attr("data-variant-id");
    const productId = $quickATCForm.attr("data-prod-id"); //Used for Free Gift
    //Get PLP ShipOn data
    var getShipOn = $(this)
      .closest("[data-quick-atc-wrap]")
      .find("label.checked")
      .data("ship-note");
    const lineItemProperties = { "Ship On": getShipOn };
    if (variantId) {
      // // Free gift with Mega 1200 or Mighty 850
      // if (productId == 8019201360063 || productId == 7989170405567) {

      //   let productsToAdd = [{
      //     id: variantId,
      //     quantity: 1,
      //     properties: {
      //       'Ship On': getShipOn
      //     }
      //   }];

      //   // Define the second product data
      //   let secondProductData = {
      //     id: 43804442132671, // Variant ID of the second product (Fuel Up Book)
      //     quantity: 1
      //   };
      //   // Add the second product to the array
      //   productsToAdd.push(secondProductData);

      //   // AJAX call to add all products
      //   $.ajax({
      //     type: 'POST',
      //     url: '/cart/add.js',
      //     data: { items: productsToAdd },
      //     dataType: 'json',
      //     success: function (response) {
      //       console.log('Products added successfully:', response);
      //       open = true;
      //       updateMinicart();
      //     },
      //     error: function (xhr, status, error) {
      //       console.error('Error adding products:', error);
      //     }
      //   });
      // } else {
      // Standard code
      addToCart(variantId, 1, lineItemProperties);
      // }
    } else {
      console.error("Variant ID is missing or invalid.");
    }
  });

  $(document).on("click", "[data-upsell-btn]", function (e) {
    const $upsellForm = $(this).closest("[data-upsell-wrap]");
    addToCart($upsellForm.data("variant-id"), 1, null);
  });

  $(document).on("click", "[data-add-to-cart-upsell]", function () {
    if ($(this).attr("data-add-to-cart-upsell") == "false") {
      $(this).attr("data-add-to-cart-upsell", "true");
      $(this).text("Added");
      const $variantSelected = $(
        "option:selected",
        $(".product-info [data-all-variants]"),
      );
      const upsellPrice = $(this).data("upsell-price");
      $(".bundle-price").text("+ " + formatMoney(upsellPrice) + " Bundle");
      $(".bundle-price-wrap").removeClass("hide");
    } else {
      $(this).attr("data-add-to-cart-upsell", "false");
      $(this).text("Bundle it");
      const $variantSelected = $(
        "option:selected",
        $(".product-info [data-all-variants]"),
      );
      $(".bundle-price-wrap").addClass("hide");
    }
  });

  $(document).on("click", ".compare-item [data-ajax-btn]", function (e) {
    e.preventDefault();
    var vId = $(this).attr("data-id");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: vId,
        quantity: 1,
      },
      dataType: "json",
      success: function () {
        open = true;
        //checkFreeItem();
        updateMinicart();
      },
      error: function () {
        console.error("Can't add item to cart");
      },
    });
  });

  $(document).on("click", "[data-pre-toggle]", function (event) {
    event.preventDefault();
    $(this).closest(".product-preorder-item").toggleClass("added");
  });

  $(document).on("click", "[data-remove-from-cart]", function () {
    var $minicartItem = $(this).closest(".minicart__item");
    var product_id = $minicartItem.attr("data-product-id");
    $(
      ".product-preorder-items .product-preorder-item[data-product_id='" +
        product_id +
        "']",
    ).removeClass("added");
    removeFromCart($minicartItem);
  });

  $(document).on("click", "[data-cart-close]", closeCartModal);
  $("[data-cart-close]").on("click", function () {
    $("#upsell-container").removeClass("active_usc");
  });
  $("[data-minicart-toggle]").on("click", function (e) {
    e.preventDefault();
    $minicart.toggleClass("is-open");
    $("html, body").toggleClass("is-cart-open");
    $("#upsell-container").toggleClass("active_usc");
  });

  $(document).on("click", "[data-qty-plus]", function () {
    updateCartItem("inc", $(this));
  });

  $(document).on("click", "[data-qty-minus]", function () {
    updateCartItem("dec", $(this));
  });

  $(document).on("click", "[data-sticky-atc-btn]", function (e) {
    e.preventDefault();
    $("[data-add-to-cart]").trigger("click");
  });

  $(document).on("cart.requestComplete", function (event, cart) {
    //checkFreeItem();
    updateMinicart();
  });
  $(document).ready(function () {
    updateMinicart();
  });

  $(document).on("click", "[data-product-upsell-variants] input", function () {
    var $option = $(this).closest(".product_option");
    var img = $option.attr("data-variant-img");
    var id = $option.attr("data-variant-id");
    var in_stock = $option.attr("data-in-stock");
    var option_value = $(this).attr("data-option_value");
    if (in_stock == "true") {
      var free_text = "";
      // if($("body").hasClass("template-product") && $(window).width() < 768) {
      //   free_text = $(".product-upsell-price div.hide--mobile").text();
      //   if(free_text != "") free_text = " - " + free_text;
      // }
      const $button = $(this)
        .closest(".product-upsell-meta")
        .find("[data-ajax-atc-btn]");
      const addLabel = $button.attr("data-label-add") || "Add to cart";
      $button.text(addLabel + free_text).prop("disabled", false);
    } else {
      const $button = $(this)
        .closest(".product-upsell-meta")
        .find("[data-ajax-atc-btn]");
      const soldOutLabel = $button.attr("data-label-sold-out") || "sold out";
      $button.text(soldOutLabel).prop("disabled", true);
    }

    var $item = $(this).closest(".product-upsell-item");
    $item.find(".product-upsell-atc-form").attr("data-id", id);
    $item
      .find(".product-upsell-image img")
      .attr("data-srcset", img)
      .attr("srcset", img);
    $option
      .closest(".product_variants")
      .find(".upsell_option")
      .find("span")
      .text(option_value);
  });

  $(document).on(
    "click",
    "[data-product-preorder-variants] input",
    function () {
      var $option = $(this).closest(".product_option");
      var img = $option.attr("data-variant-img");
      var id = $option.attr("data-variant-id");
      var in_stock = $option.attr("data-in-stock");

      if (in_stock == "true") {
        var free_text = "";
        // if($("body").hasClass("template-product") && $(window).width() < 768) {
        //   free_text = $(".product-upsell-price div.hide--mobile").text();
        //   if(free_text != "") free_text = " - " + free_text;
        // }product-preorder-item
        $(this)
          .closest(".product-preorder-meta")
          .find("[data-pre-toggle] .label-add")
          .text("add" + free_text);
        $(this)
          .closest(".product-preorder-meta")
          .find("[data-pre-toggle]")
          .prop("disabled", false);
      } else {
        $(this).closest(".product-preorder-item").removeClass("added");
        $(this)
          .closest(".product-preorder-meta")
          .find("[data-pre-toggle] .label-add")
          .html("sold out");
        $(this)
          .closest(".product-preorder-meta")
          .find("[data-pre-toggle]")
          .prop("disabled", true);
      }
      var $item = $(this).closest(".product-preorder-item");
      $item.find(".product-preorder-atc-form").attr("data-id", id);
      $item
        .find(".product-preorder-image img")
        .attr("data-srcset", img)
        .attr("srcset", img);
    },
  );

  $(document).on(
    "click",
    ".product-upsell-item .product-upsell-atc-form [data-ajax-atc-btn]",
    function (e) {
      e.preventDefault();
      const $form = $(this).closest(".product-upsell-atc-form");
      const variantId = $form.attr("data-id");
      if (!variantId) return;

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: variantId,
          quantity: 1,
        },
        success: function () {
          open = true;
          updateMinicart();
        },
      });
    },
  );

  $(document).on(
    "click",
    ".product-preorder-item:not(.added) .product-preorder-atc-form [data-ajax-atc-btn]",
    function (e) {
      e.preventDefault();
      var $item = $(this).closest(".product-preorder-item");
      var vId = $(this).closest(".product-preorder-atc-form").attr("data-id");
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: vId,
          quantity: 1,
        },
        success: function (cart) {
          $item.addClass("added");
          open = true;
          //checkFreeItem();
          updateMinicart();
        },
      });
    },
  );

  $(document).on(
    "click",
    ".product-preorder-item.added [data-ajax-atc-btn]",
    function (e) {
      e.preventDefault();
      var $item = $(this).closest(".product-preorder-item");
      var $form = $item.find(".product-preorder-atc-form");
      var vId = $form.attr("data-id");
      var updateQuery = "updates[" + vId + "]=0";
      jQuery.post("/cart/update.js", updateQuery, function () {
        $item.removeClass("added");
        open = true;
        //checkFreeItem();
        updateMinicart();
      });
    },
  );

  $(document).on("click", ".btn-save-cart-note", function () {
    let note = $(".gift-note").val().trim();

    $.ajax({
      url: "/cart/update.js",
      type: "POST",
      data: {
        note: note,
      },
      success: function (result) {
        updateMinicart();
        $(".gift-wrapper .minicart-small-title").toggleClass("active");
        $(".minicart__gift").slideToggle();
        $(".gift-wrapper .edit_text").show();
      },
      error: function (jqxhr, status, exception) {
        console.log(exception);
      },
    });
  });

  $(document).on("click", ".gift-wrapper .minicart-small-title", function () {
    $(this).toggleClass("active");
    $(".minicart__gift").slideToggle();
  });
};

const updateCartItem = function (param, handle) {
  var id = handle.closest(".minicart__item").attr("data-id");
  var qty = parseInt(handle.parent(".item__qty").find("[data-qty]").text());
  if (param == "inc") {
    qty += 1;
    updateQty(id, qty);
  } else {
    if (qty != 1) {
      qty -= 1;
      updateQty(id, qty);
    }
  }
};

const updateQty = function (id, qty) {
  jQuery.post("/cart/update.js", "updates[" + id + "]=" + qty, function () {
    //checkFreeItem();
    updateMinicart();
  });
};

const init = function () {
  if (tinybind) {
    tinybind.formatters.formatMoney = formatMoney;
    tinybind.formatters.isDefaultTitle = function (title) {
      if (title.toLowerCase() == "default title") return false;
      // Check if it is gift card and value that ends  with .00
      if (title.includes(".00")) return false;
      return true;
    };
    tinybind.formatters.append = function (value, append) {
      return value + append;
    };
    tinybind.formatters.is_preorder = function (item) {
      if (item["properties"] == undefined) return false;
      if (item["properties"]["preorder"]) {
        return true;
      }
      return false;
    };
    tinybind.formatters.is_discount = function (item) {
      if (item["discounts"] != undefined) {
        if (item["discounts"].length != 0) {
          return true;
        }
      }
      return false;
    };
    tinybind.formatters.is_discount_and_not_zero = function (item) {
      if (item["discounts"] != undefined && item["discounts"].length != 0) {
        return (
          item["original_price"] > item["discounted_price"] &&
          item["original_price"] - item["discounted_price"] > 0
        );
      }
      return false;
    };

    tinybind.formatters.is_compare = function (item) {
      if (item["discounts"] != undefined) {
        if (item["discounts"].length != 0) {
          return false;
        }
      }
      if (item["compare_at_price"] != undefined) {
        return true;
      }
      return false;
    };

    tinybind.formatters.is_regular = function (item) {
      if (item["discounts"] != undefined) {
        if (item["discounts"].length != 0) {
          return false;
        }
      }
      if (item["compare_at_price"] != undefined) {
        return false;
      }
      return true;
    };

    tinybind.formatters.is_compare_in_cart = function (cart) {
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];

        // Check if the item has no discounts
        if (!item["discounts"] || item["discounts"].length === 0) {
          // Check if the compare price exists and is greater than the actual price
          if (item["compare_at_price"] > item["price"]) {
            return true; // Found an item with a valid compare price
          }
        }
      }
      return false; // No valid compare prices found
    };

    tinybind.formatters.empty_note = function (cart_note) {
      if (cart_note != undefined) {
        if (cart_note.length != 0) {
          return false;
        }
      }
      return true;
    };
    tinybind.formatters.is_free = function (item) {
      if (item["discounts"] != undefined) {
        if (item["discounts"].length != 0) {
          if (item["discounted_price"] != 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
    tinybind.formatters.get_discount = function (item) {
      if (item["discounts"] != undefined) {
        if (item["discounted_price"] != item["price"]) {
          return item["discounted_price"];
        } else {
          return false;
        }
      }
      return false;
    };

    tinybind.formatters.get_compare = function (item) {
      if (item["compare_at_price"] != undefined) {
        if (item["compare_at_price"] != item["price"]) {
          return item["compare_at_price"];
        } else {
          return null;
        }
      }
      return false;
    };

    tinybind.formatters.get_compare_subtotal = function (cart) {
      let subtotal = 0;
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
        if (item["discounts"] != undefined) {
          if (item["discounted_price"] != item["price"]) {
            subtotal += item["discounted_price"] * item["quantity"];
          } else {
            if (item["compare_at_price"] != undefined) {
              if (item["compare_at_price"] != item["price"]) {
                subtotal += item["compare_at_price"] * item["quantity"];
              } else {
                subtotal += item["compare_at_price"] * item["quantity"];
              }
            } else {
              subtotal += item["price"] * item["quantity"];
            }
          }
        }
      }
      return subtotal;
    };

    tinybind.formatters.convert = function (value, append) {
      if (append) {
        return "/products/" + append;
      }
      return value;
    };
    tinybind.bind($minicart, data);
  } else {
    console.error("minicart.js: Tinybind template library is not connected");
    return false;
  }

  initMinicartScrollbar();

  if (
    localStorage.getItem("opened_side_cart") == "true" &&
    window.location.pathname == "/"
  ) {
    $("[data-minicart]").addClass("is-open");
    $("html, body").addClass("is-cart-open");
    localStorage.setItem("opened_side_cart", false);
  }
};
export default function () {
  init();
  eventHandlers();
}

// BEAST MINI CROSS-SELL ATC
$("#upsell_atc_bm").on("submit", function (event) {
  event.preventDefault(); // Prevent the default form submission

  // Prevent multiple clicks
  $("#upsell_atc_bm #add-to-cart-button").prop("disabled", true);

  // Retrieve product IDs from session storage
  var mainProductId = sessionStorage.getItem("bmp_sesh");
  var upsellProductId = sessionStorage.getItem("bmu_sesh");

  // get Ship On data
  let ship_on = $(this)
    .closest(".section-product_main")
    .find(".prod_active div.checked")
    .data("ships-on");

  // Initialize the items array
  var items = [
    {
      id: mainProductId,
      quantity: 1,
      properties: {
        "Ship On": ship_on, // 'Ship On' is the property name, and ship_on is the dynamic value
      },
    },
  ];
  // Add upsell product if available
  if (upsellProductId) {
    let ship_on_cs = $(this)
      .closest(".section-product_main")
      .find(".prod_active div.upsell_Active")
      .data("ships-on");
    items.push({
      id: upsellProductId,
      quantity: 1,
      properties: { "Ship On": ship_on_cs },
    });
  }

  // Function to add a single item to the cart
  function addItemToCart(item, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: item,
      dataType: "json",
      success: function (response) {
        //console.log(`Product ${item.id} added to cart!`);
        if (callback) callback();
        $("#upsell_atc_bm #add-to-cart-button").prop("disabled", false);
      },
      error: function (xhr, status, error) {
        //console.log(`Failed to add product ${item.id} to cart.`, xhr.responseText);
        if (callback) callback(error);
      },
    });
  }

  // Recursive function to add all items
  function addAllItems(items, index = 0) {
    if (index >= items.length) {
      // All items processed
      updateMinicart();
      refreshRecommend();
      $("[data-minicart]").addClass("is-open");
      return;
    }

    addItemToCart(items[index], function (error) {
      if (error) {
        // console.log('Stopping further requests due to an error.');
        return;
      }
      // Process next item
      addAllItems(items, index + 1);
    });
  }
  // Start adding items
  addAllItems(items);
});

// CART CROSS-SELL
function checkCartAndFetchCrossSell() {
  // List your handles
  const ProductHandles_1 = ["the-mini-by-beast"];
  const ProductHandles_2 = ["the-mini-by-beast-plus"];
  const ProductHandles_3 = ["b10-health-blender"];
  const ProductHandles_4 = ["beastmode-blender"];
  const ProductHandles_5 = ["b10-full-system"];
  const ProductHandles_6 = ["beastmode-blender"];

  // List your collections
  const collection_1 = "cs_mini_base";
  const collection_2 = "cs_mini_plus";
  const collection_3 = "cs_beast_base";
  const collection_4 = "cs_beast_base";
  const collection_5 = "cs_beast_plus";
  const collection_6 = "cs_beast_plus";

  // List your upsell collections
  const collection_upsell_1 = "us_mini_base";
  const collection_upsell_2 = "";
  const collection_upsell_3 = "us_b10_base";
  const collection_upsell_4 = "us_beastmode_base";
  const collection_upsell_5 = "";
  const collection_upsell_6 = "";

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const crossSellContainer = document.getElementById(
        "cross-sell-container",
      );
      const isMobile = window.innerWidth < 990;
      const upsellContainer = isMobile
        ? document.getElementById("upsell-container-mobile")
        : document.getElementById("upsell-container");

      if (!crossSellContainer && !upsellContainer) {
        return;
      }

      if (cart.items.length === 0) {
        if (crossSellContainer) crossSellContainer.innerHTML = ""; // Clear the container if the cart is empty
        if (upsellContainer) upsellContainer.innerHTML = ""; // Clear the upsell container if the cart is empty
        return;
      }

      // Collect the handles of items in the cart
      const cartHandles = cart.items.map((item) => item.handle);

      // Check for matching products in the cart
      let matchingProductHandles = [
        {
          handles: ProductHandles_1,
          collection: collection_1,
          upsell: collection_upsell_1,
        },
        {
          handles: ProductHandles_2,
          collection: collection_2,
          upsell: collection_upsell_2,
        },
        {
          handles: ProductHandles_3,
          collection: collection_3,
          upsell: collection_upsell_3,
        },
        {
          handles: ProductHandles_4,
          collection: collection_4,
          upsell: collection_upsell_4,
        },
        {
          handles: ProductHandles_5,
          collection: collection_5,
          upsell: collection_upsell_5,
        },
        {
          handles: ProductHandles_6,
          collection: collection_6,
          upsell: collection_upsell_6,
        },
      ];

      let foundItem = null;
      let selectedCollection = "";
      let selectedUpsellCollection = "";

      for (const productGroup of matchingProductHandles) {
        if (productGroup.handles.length > 0) {
          foundItem = cart.items.find((item) =>
            productGroup.handles.includes(item.handle),
          );
          if (foundItem) {
            selectedCollection = productGroup.collection;
            selectedUpsellCollection = productGroup.upsell;
            break;
          }
        }
      }

      // Clear containers initially
      if (crossSellContainer) crossSellContainer.innerHTML = "";
      if (upsellContainer) upsellContainer.innerHTML = "";

      // Fetch the cross-sell collection if defined
      if (selectedCollection) {
        fetch(`/collections/${selectedCollection}/products.json`)
          .then((response) => response.json())
          .then((crossSellData) => {
            const filteredCrossSellProducts = crossSellData.products.filter(
              (product) => !cartHandles.includes(product.handle),
            );
            renderProducts(
              filteredCrossSellProducts,
              foundItem.variant_title,
              crossSellContainer,
              "cross-sell",
              true,
            );
          })
          .catch((error) => console.error("Error fetching collection:", error));
      }

      // Fetch the upsell collection if defined
      if (selectedUpsellCollection) {
        fetch(`/collections/${selectedUpsellCollection}/products.json`)
          .then((response) => response.json())
          .then((upsellData) => {
            const filteredUpsellProducts = upsellData.products.filter(
              (product) => !cartHandles.includes(product.handle),
            );
            renderProducts(
              filteredUpsellProducts,
              foundItem.variant_title,
              upsellContainer,
              "upsell",
              false,
            );
          })
          .catch((error) =>
            console.error("Error fetching upsell collection:", error),
          );
      }

      // If neither collection is defined, do nothing
      if (!selectedCollection && !selectedUpsellCollection) {
        if (crossSellContainer) crossSellContainer.innerHTML = "";
        if (upsellContainer) upsellContainer.innerHTML = "";
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

function renderProducts(products, selectedColor, container, type, isSlider) {
  if (!container) return;

  // Clear previous content
  container.innerHTML = "";

  // Create a title for the section
  let titleXsell = `<h4>You might also like:</h4>`;
  let titleUpsell = `<h3>Discover the next level</h3>`;
  container.innerHTML += titleXsell;

  // Filter products based on the selected color or "Default Title"
  const filteredProducts = products.filter((product) =>
    product.variants.some(
      (variant) =>
        variant.option1 === selectedColor ||
        variant.option1 === "Default Title",
    ),
  );

  if (isSlider) {
    // Create a slider container
    let sliderHTML = `<div class="${type}_slider" data-slider>`;

    filteredProducts.forEach((product) => {
      const matchingVariant = product.variants.find(
        (variant) =>
          variant.option1 === selectedColor ||
          variant.option1 === "Default Title",
      );
      if (matchingVariant) {
        // Render product in slider format
        sliderHTML += `
          <div class="minicart__item crossell_item crossell-${
            matchingVariant.available
          }">
            <a class="minicart__item-main no-hover-link">
              <img class="minicart__item-image" src="${
                matchingVariant.featured_image.src
              }" alt="${matchingVariant.featured_image.alt}">
            </a>
            <div class="minicart__item-info">
              <div class="minicart__item-title">
                <a href="/products/${product.handle.replace(
                  /-xsell$/,
                  "",
                )}?variant=${matchingVariant.id}">${product.title}</a>
              </div>
              <div class="minicart__item-list">
                <div class="minicart__item-price">
                  <span class="org_price localized-price">$${
                    matchingVariant.price
                  }</span>
                  ${
                    matchingVariant.compare_at_price != null
                      ? `<span class="compare_price localized-price">$${matchingVariant.compare_at_price}</span>`
                      : ""
                  }
                </div>
              </div>
              <form class="upsell_atc" data-variant-id="${matchingVariant.id}"">
                <button type="submit" class="add-to-cart-button d-flex button_style_button2">Add</button>
              </form>
            </div>
          </div>
        `;
      }
    });

    sliderHTML += `</div>`;
    container.innerHTML += sliderHTML;

    // Destroy any previous instance of Slick slider before initializing
    if ($(`.${type}_slider`).hasClass("slick-initialized")) {
      $(`.${type}_slider`).slick("unslick");
    }

    // Initialize the Slick Slider after content is added
    $(document).ready(function () {
      $(`.${type}_slider`).slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      });
    });
  } else {
    // Render upsell products in card format
    let upsellHTML = `<div class="upsell-inner-wrap usell_slider" data-slider>`;

    filteredProducts.forEach((product) => {
      const matchingVariant = product.variants.find(
        (variant) =>
          variant.option1 === selectedColor ||
          variant.option1 === "Default Title",
      );
      if (matchingVariant) {
        // Render product in card format
        upsellHTML += `
          <div class="upsell_item upsell-${matchingVariant.available}">
            <a class="minicart__item-main">
              <img class="minicart__item-image" src="${
                matchingVariant.featured_image.src
              }" alt="${matchingVariant.featured_image.alt}">
            </a>
            <div class="minicart__item-info">
              <div class="minicart__item-title">
                <a href="/products/${product.handle.replace(
                  /-xsell$/,
                  "",
                )}?variant=${matchingVariant.id}">${product.title}</a>
              </div>
              <div class="minicart__item-list">
                <div class="minicart__item-price">
                  <span class="org_price localized-price">$${
                    matchingVariant.price
                  }</span>
                  ${
                    matchingVariant.compare_at_price != null
                      ? `<span class="compare_price localized-price">$${matchingVariant.compare_at_price}</span>`
                      : ""
                  }
                </div>
              </div>
              <form class="upsell_atc" data-variant-id="${matchingVariant.id}">
                <button type="submit" class="add-to-cart-button">Upgrade your Beast<span>™</span></button>
              </form>
            </div>
          </div>
        `;
      }
    });
    upsellHTML += `</div>`;
    container.innerHTML += titleUpsell += upsellHTML;

    // Destroy any previous instance of Slick slider before initializing
    if ($(`.usell_slider`).hasClass("slick-initialized")) {
      $(`.usell_slider`).slick("unslick");
    }

    // Initialize the Slick Slider for upsell products
    $(document).ready(function () {
      $(".usell_slider").slick({
        slidesToShow: 3,
        infinite: true,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }

  // Bind the add-to-cart function for upsell items
  $(".upsell_atc").on("submit", function (event) {
    event.preventDefault();
    const variantId = $(this).data("variant-id");
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: { "Exclusive Offer": "Cart" },
        },
      ],
    };

    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(formData),
      dataType: "json",
      success: function (data) {
        updateMinicart();
        refreshRecommend();
      },
      error: function (jqXHR) {
        console.error(
          "There was a problem with the fetch operation:",
          jqXHR.responseText,
        );
      },
    });
  });
}

// Ship On Data Check - Runs in updateMinicart
function checkShipOnProperty() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      //console.log(cart);
      // Flag to check if any item has the 'Ship On' property
      var hasShipOnProperty = false;

      $.each(cart.items, function (index, item) {
        // console.log(item);
        // Check if the item has the 'Ship On' property
        if (item.properties && item.properties["Ship On"]) {
          // Log the 'Ship On' property for debugging
          // console.log("Product has Ship On:", item.properties["Ship On"]);
          // Set the flag to true since we found the property
          hasShipOnProperty = true;
          // Find the corresponding .minicart__item element in the DOM
          var minicartItem = $(".minicart__item .mini-cart-ships-on").eq(index);

          // Check if the .shipon_msg div already exists for this item
          if (minicartItem.find(".shipon_msg").length === 0) {
            // Remove any existing .shipon_msg before appending the new one
            minicartItem.find(".shipon_msg").remove();

            // Create a new div to append to the minicart item
            var shipOnDiv = $('<div class="shipon_msg"></div>').text(
              item.properties["Ship On"],
            ); // Set the content of the div

            // Append the new div to the minicart item
            minicartItem.append(shipOnDiv);
          }
        }
      });

      // Log if no item in the cart has the 'Ship On' property
      // if (!hasShipOnProperty) {
      //   console.log('No product in cart has the "Ship On" date.');
      // }
    },
    error: function (xhr, status, error) {
      console.error("Error checking cart:", error);
    },
  });
}
